export const saveAuth = ({ token, user }) => {
    // تأمين إضافي: لو الداتا جاية مشوهة ميسيفهاش أصلاً
    if (token) localStorage.setItem("token", token);
    if (user) localStorage.setItem("user", JSON.stringify(user));
};

export const clearAuth = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
};

export const getToken = () => localStorage.getItem("token");

export const getUser = () => {
    const raw = localStorage.getItem("user");
    
    // التعديل السحري هنا:
    // بنتأكد إن raw مش null ومش كلمة "undefined" كـ string
    if (raw && raw !== "undefined" && raw !== "null") {
        try {
            return JSON.parse(raw);
        } catch (e) {
            console.error("Failed to parse user data", e);
            return null;
        }
    }
    return null;
};

export const isAdmin = () => {
    const user = getUser();
    return user?.role === "admin";
};